module.exports = "<div class=fares-chart-tooltip><%= text%></div>";